import { observer } from 'mobx-react-lite'
import { ChangeEvent, useState } from 'react'
import { Button, Card, Form, Modal, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import ErrorMessage from '../components/ErrorMessage'
import { useStore } from '../../app/stores/store'
import Export from '../components/export/Export'

function EditGender({ handleClose }: any) {
  const { userStore, profileStore } = useStore()
  const { getData } = userStore
  const [gender, setGender] = useState({
    gender: getData?.gender || 0,
  })
  const [error, setError] = useState('')
  const [loadingBtn, setLoadingBtn] = useState(false)
  const { t } = useTranslation()

  const handleInputChange = (event: ChangeEvent<any>) => {
    const newValue = parseInt(event.target.value)
    if (!isNaN(newValue)) {
      setGender({ ...gender, gender: newValue })
      setError('')
    }
  }

  const genderOptions = Export()

  const handleSubmit = async (e: any) => {
    setLoadingBtn(true)
    e.preventDefault()

    profileStore.changeUserGender(gender.gender).finally(() => {
      setLoadingBtn(false)
      handleClose()
      setError('')
    })
  }

  const buttons = [
    {
      title: t('cancel'),
      onClick: handleClose,
      className: 'text-white payment-button-cancel',
    },
    {
      title: t('edit'),
      className: 'text-white payment-button-tryagain',
      type: 'submit',
    },
  ]

  return (
    <Card className="newFont prevent-select">
      <Modal.Header>
        <p className="login-card-title">{t('gender')}</p>
        <Button variant="inherit" onClick={handleClose} className="close me-2">
          <i className="fa-regular fa-x icon-size" />
        </Button>
      </Modal.Header>
      <Modal.Body className="card-padding card-font-size">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3 profile-password">
            <Form.Label>{t('gender_details.select')}</Form.Label>
            <Form.Select
              className="card-input-style"
              value={gender.gender}
              onChange={handleInputChange}
            >
              {genderOptions.map((genderOption) => (
                <option key={genderOption.value} value={genderOption.value}>
                  {t(genderOption.label)}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          {error && typeof error === 'string' && (
            <ErrorMessage text={error} setError={() => setError('')} />
          )}
          <div className="auction-create-buttons">
            {buttons.map((button) => (
              <button
                key={button.title}
                onClick={button.onClick}
                disabled={loadingBtn}
                type={button.type === 'submit' ? 'submit' : 'button'}
                className={`text-white ${button.className}`}
              >
                {loadingBtn && button.title === t('edit') ? (
                  <Spinner animation="border" variant="light" />
                ) : (
                  button.title
                )}
              </button>
            ))}
          </div>
        </Form>
      </Modal.Body>
    </Card>
  )
}
export default observer(EditGender)
